import { resolveStorageUrl } from "./adminApiHelpers";
import { firstDefined, isPlainObject } from "./objectHelpers";

function resolveItemImage(item) {
  const full = item?.image_url;
  if (full != null && typeof full === "string" && full.trim()) {
    return full.trim();
  }
  return resolveStorageUrl(item?.image ? String(item.image) : "");
}

/**
 * References, services: title + description + image (API may nest { ar, en }).
 */
export function normalizeTitleDescriptionItem(raw) {
  if (!raw || typeof raw !== "object") return null;
  const item = isPlainObject(raw.attributes) ? raw.attributes : raw;
  const id = item.id ?? raw.id;
  if (id == null) return null;

  const str = (v) => (v == null ? "" : String(v));

  const titleObj = isPlainObject(item.title) ? item.title : null;
  const descObj = isPlainObject(item.description) ? item.description : null;

  return {
    id,
    title_ar: str(
      titleObj?.ar ??
        firstDefined(item, ["title_ar", "titleAr", "ar_title", "title_arabic"])
    ),
    title_en: str(
      titleObj?.en ??
        ((typeof item.title === "string" ? item.title : "") ||
          firstDefined(item, [
            "title_en",
            "titleEn",
            "en_title",
            "title_english",
          ]))
    ),
    description_ar: str(
      descObj?.ar ??
        firstDefined(item, [
          "description_ar",
          "descriptionAr",
          "body_ar",
          "text_ar",
        ])
    ),
    description_en: str(
      descObj?.en ??
        ((typeof item.description === "string" ? item.description : "") ||
          firstDefined(item, [
            "description_en",
            "descriptionEn",
            "body_en",
            "text_en",
            "description",
          ]))
    ),
    image_url: resolveItemImage(item),
  };
}
